module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "right",
      "label-width": "82px"
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    attrs: {
      "label": "推广员等级"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "开启推广员等级后，推广员可以通过提升等级来建立自己的推广团队，并且获取团队奖金",
      "type": "info",
      "close-text": " "
    }
  }), _vm._v(" "), _c('el-switch', {
    attrs: {
      "width": 50,
      "active-value": "true",
      "inactive-value": "false",
      "inactive-color": "#ccc",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.isOpenPromoterGrade),
      callback: function($$v) {
        _vm.$set(_vm.form, "isOpenPromoterGrade", $$v)
      },
      expression: "form.isOpenPromoterGrade"
    }
  })], 1), _vm._v(" "), (_vm.form.isOpenPromoterGrade == 'true') ? [_c('el-form-item', {
    attrs: {
      "label": "统计周期"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "推广员升级的统计周期，累计或者月度统计（当月数据满足升级条件，不包含其他月份数据）",
      "type": "info",
      "close-text": " "
    }
  }), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.upgrade.stat_cycle),
      callback: function($$v) {
        _vm.$set(_vm.form.upgrade, "stat_cycle", $$v)
      },
      expression: "form.upgrade.stat_cycle"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "total"
    }
  }, [_vm._v(" 累计 ")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "month_total"
    }
  }, [_vm._v(" 月度统计 ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "升级条件"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "直属下线数量达到X人"
    },
    model: {
      value: (_vm.form.upgrade.filter.children_num),
      callback: function($$v) {
        _vm.$set(_vm.form.upgrade.filter, "children_num", $$v)
      },
      expression: "form.upgrade.filter.children_num"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "直属下线销售总额达到X元"
    },
    model: {
      value: (_vm.form.upgrade.filter.children_sales_amount),
      callback: function($$v) {
        _vm.$set(_vm.form.upgrade.filter, "children_sales_amount", $$v)
      },
      expression: "form.upgrade.filter.children_sales_amount"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "成为指定付费等级会员"
    },
    model: {
      value: (_vm.form.upgrade.filter.grade_member),
      callback: function($$v) {
        _vm.$set(_vm.form.upgrade.filter, "grade_member", $$v)
      },
      expression: "form.upgrade.filter.grade_member"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "等级配置"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "等级一，等级二，等级三......为有低到高，等级一为最低",
      "type": "info",
      "close-text": " ",
      "description": "直接获取一级团队分红比例：表示推广员的直属上级为三级推广员，中间无二级推广员"
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "grade-setting-row",
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.form.grade), function(item, key) {
    return _c('el-col', {
      key: key,
      staticClass: "grade-setting-col",
      attrs: {
        "span": 8
      }
    }, [_c('el-tag', [_vm._v(_vm._s(item.name))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v("等级名称")]), _vm._v(" "), _c('el-input', {
      staticClass: "grade-setting-item",
      attrs: {
        "placeholder": "自定义等级名称",
        "maxlength": 30,
        "minlength": 1
      },
      model: {
        value: (_vm.form.grade[key].custom_name),
        callback: function($$v) {
          _vm.$set(_vm.form.grade[key], "custom_name", $$v)
        },
        expression: "form.grade[key].custom_name"
      }
    }), _vm._v(" "), (item.grade_level > 1) ? _c('div', [_c('span', {
      staticClass: "title"
    }, [_vm._v("升级条件")]), _vm._v(" "), (_vm.form.upgrade.filter.children_num) ? _c('el-input', {
      staticClass: "grade-setting-item",
      attrs: {
        "type": "number",
        "required": "",
        "min": "0"
      },
      model: {
        value: (_vm.form.grade[key].children_num),
        callback: function($$v) {
          _vm.$set(_vm.form.grade[key], "children_num", $$v)
        },
        expression: "form.grade[key].children_num"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("直属下线数量")])], 2) : _vm._e(), _vm._v(" "), (_vm.form.upgrade.filter.children_sales_amount) ? _c('el-input', {
      staticClass: "grade-setting-item",
      attrs: {
        "type": "number",
        "required": "",
        "min": "0"
      },
      model: {
        value: (_vm.form.grade[key].children_sales_amount),
        callback: function($$v) {
          _vm.$set(_vm.form.grade[key], "children_sales_amount", $$v)
        },
        expression: "form.grade[key].children_sales_amount"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("直属下线销售总额")])], 2) : _vm._e(), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.upgrade.filter.grade_member),
        expression: "form.upgrade.filter.grade_member"
      }],
      model: {
        value: (_vm.form.grade[key].grade_member),
        callback: function($$v) {
          _vm.$set(_vm.form.grade[key], "grade_member", $$v)
        },
        expression: "form.grade[key].grade_member"
      }
    }, _vm._l((_vm.vipGradeList), function(item) {
      return _c('el-option', {
        key: item.lv_type,
        attrs: {
          "label": item.grade_name,
          "value": item.lv_type
        }
      })
    }), 1)], 1) : _vm._e(), _vm._v(" "), (item.grade_level == 2) ? _c('div', [_c('span', {
      staticClass: "title"
    }, [_vm._v("团队分红比例")]), _vm._v(" "), _c('el-input', {
      staticClass: "grade-setting-item",
      attrs: {
        "type": "number",
        "required": "",
        "min": "0"
      },
      model: {
        value: (_vm.form.grade[key].first_ratio),
        callback: function($$v) {
          _vm.$set(_vm.form.grade[key], "first_ratio", $$v)
        },
        expression: "form.grade[key].first_ratio"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("%")])], 2)], 1) : _vm._e(), _vm._v(" "), (item.grade_level == 3) ? _c('div', [_c('span', {
      staticClass: "title"
    }, [_vm._v("直接获取一级团队分红比例")]), _vm._v(" "), _c('el-input', {
      staticClass: "grade-setting-item",
      attrs: {
        "type": "number",
        "required": "",
        "min": "0"
      },
      model: {
        value: (_vm.form.grade[key].first_ratio),
        callback: function($$v) {
          _vm.$set(_vm.form.grade[key], "first_ratio", $$v)
        },
        expression: "form.grade[key].first_ratio"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("%")])], 2), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v("获取二级团队分红比例")]), _vm._v(" "), _c('el-input', {
      staticClass: "grade-setting-item",
      attrs: {
        "type": "number",
        "required": "",
        "min": "0"
      },
      model: {
        value: (_vm.form.grade[key].second_ratio),
        callback: function($$v) {
          _vm.$set(_vm.form.grade[key], "second_ratio", $$v)
        },
        expression: "form.grade[key].second_ratio"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("%")])], 2)], 1) : _vm._e()], 1)
  }), 1)], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保 存")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-78d6fefd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78d6fefd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/popularize/promoterSetting.vue
// module id = 2844
// module chunks = 0